module.exports = __webpack_public_path__ + "static/img/img-home1.41ee6484.png";